$(".how-it-works-item").wrapAll("<div class='how-it-works-tab'></div>");
$(document).ready(function () {
  $(".how-it-works-question").click(function () {
    var answer = $(this).next(".how-it-works-answer");
    $(".how-it-works-answer").not(answer).slideUp();
    $(".how-it-works-item").not($(this).parent()).removeClass("opened");
    answer.slideToggle();
    $(this).parent().toggleClass("opened");
  });
});

// $(document).ready(function () {
//   $(".ingr-slider").slick({
//     dots: false,
//     arrows: true,
//     infinite: false,
//     speed: 500,
//     appendArrows: $(".slide_icons"),
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10L8 14L6 14L-2.62268e-07 8L6 2L8 2L8 6L16 6L16 10L8 10Z" fill="white"/></svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 6L8 2L10 2L16 8L10 14L8 14L8 10L-1.74845e-07 10L-3.01991e-07 6L8 6Z" fill="white"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 989,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         }
//       }
//     ]
//   });
// });

// $(document).ready(function () {
//   $(".clients-slider").slick({
//     dots: false,
//     arrows: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         }
//       }
//     ]
//   });
// });



